<template>
    <div class="window-wrapper window-file-size-error">
        <div class="window-overlay"></div>
        <div class="window window-small">
            <div class="window-inner">
                <div class="window-one-column">
                    <div class="window-text">Недопустимый размер файла. Пожалуйста, выберите файл размером до {{ size }} МБ.</div>
                    <div class="button-block">
                        <button @click="closeWindow" class="button button-dark button-close-window">ОК</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "FileSizeErrorWindow",
    props: ["size"],
    methods: {
        closeWindow() {
            $('.window-wrapper').removeClass('window-open');
            $('body').removeClass('blocked');
        }
    }
}
</script>

<style scoped>

</style>